const state = {
};

const getters = {};
const actions = {
	GenerateSshKey({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('utilities.generate_ssh_key');
			this._vm.$axios.post(r, {
				generate_data: payload,
			})
				.then((response) => {
					if (response.data.call_status === "OK") {
						resolve(response.data.data);
					} else {
						reject(response.data.error);
					}
				})
				.catch((error) => {
					reject(error);
				})
				.finally(() => {});
		});
	},

	GetAccountPid({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('utilities.get_account_pid');
			this._vm.$axios.get(r)
				.then((response) => {
					if (response.data.call_status === "OK") {
						resolve(response.data.data);
					} else {
						reject(response.data.error);
					}
				})
				.catch((error) => {
					reject(error);
				})
				.finally(() => {});
		});
	},

	AccountSystemRestart({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('utilities.system_restart');
			this._vm.$axios.get(r)
				.then((response) => {
					if (response.data.call_status === "OK") {
						resolve(response.data.data);
					} else {
						reject(response.data.error);
					}
				})
				.catch((error) => {
					reject(error);
				})
				.finally(() => {});
		});
	},
};
const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
